import moment from "moment-timezone";

export const ISSUECOLS = [
	{
		title: "Alarm Device",
		field: "alarm",
		render: (rowData) => (rowData.alarm === null ? "-" : rowData.alarm),
	},
	{
		title: "Issue Category",
		field: "problem",
		render: (rowData) => (rowData.problem === null ? "-" : rowData.problem),
	},
	{
		title: "Issue Date",
		field: "issue_date",
		render: (rowData) =>
			rowData.issue_date === null ||
			rowData.issue_date === undefined ||
			rowData.issue_date === ""
				? ""
				: moment(rowData.issue_date).format("YYYY-MM-DD HH:mm"),
	},
	{ title: "Issue Description", field: "gy_issue" },
	{
		title: "Unavailability",
		field: "unavailability",
		render: (rowData) =>
			rowData.unavailability === null ? "-" : rowData.unavailability,
	},
	{
		title: "Latest Action Date",
		field: "action_date",
		render: (rowData) =>
			rowData.action_date === null ||
			rowData.action_date === undefined ||
			rowData.action_date === ""
				? ""
				: moment(rowData.action_date).format("YYYY-MM-DD HH:mm"),
	},
	{ title: "Latest Action Description", field: "gy_action" },
	{ title: "Status", field: "status" },
];

export const ALLISSUECOLS = [
	{ title: "Client", field: "company" },
	{ title: "Site", field: "site_name" },
	{ title: "SF Project ID", field: "SF_project_id" },
	{
		title: "Alarm Device",
		field: "alarm",
		render: (rowData) => (rowData.alarm === null ? "-" : rowData.alarm),
	},
	{
		title: "Issue Category",
		field: "problem",
		render: (rowData) => (rowData.problem === null ? "-" : rowData.problem),
	},
	{
		title: "Issue Date",
		field: "issue_date",
		render: (rowData) =>
			rowData.issue_date === null ||
			rowData.issue_date === undefined ||
			rowData.issue_date === ""
				? ""
				: moment(rowData.issue_date).format("YYYY-MM-DD HH:mm"),
	},
	{ title: "Issue Description", field: "gy_issue" },
	{
		title: "Unavailability",
		field: "unavailability",
		render: (rowData) =>
			rowData.unavailability === null ? "-" : rowData.unavailability,
	},
	{
		title: "Category Unavailability",
		field: "cat_un",
		render: (rowData) => (rowData.cat_name === null ? "-" : rowData.cat_name),
	},
	{
		title: "Sub Category Unavailability",
		field: "sub_cat_un",
		render: (rowData) =>
			rowData.sub_cat_name === null ? "-" : rowData.sub_cat_name,
	},
	{
		title: "Latest Action Date",
		field: "action_date",
		render: (rowData) =>
			rowData.action_date === null ||
			rowData.action_date === undefined ||
			rowData.action_date === ""
				? ""
				: moment(rowData.action_date).format("YYYY-MM-DD HH:mm"),
	},
	{ title: "Latest Action Description", field: "gy_action" },
	{ title: "Status", field: "status" },
];

export const SITEITCOLS = [
	{
		title: "Country of Site",
		field: "country",
		headerStyle: { display: "none", width: "0px", maxWidth: "0px" },
		cellStyle: { display: "none", width: "0px", maxWidth: "0px" },
	},
	{ title: "First Sync Date", field: "sync", editable: "never" },
	{ title: "Client", field: "temp_client_name", editable: "never" },
	{ title: "Site", field: "site_name", editable: "never" },
	{
		title: "Table Name",
		field: "table_name",
		render: (rowData) =>
			rowData.table_name === null ? "-" : rowData.table_name,
	},
];

export const SITEOTHERSCOLS = [
	{
		title: "Date",
		field: "dateCreated",
		dateSetting: { locale: moment().locale() },
		type: "date",
	},
	{
		title: "Client",
		field: "temp_client_name",
		render: (rowData) =>
			rowData.temp_client_name === null ? "-" : rowData.temp_client_name,
	},
	{
		title: "Site",
		field: "site_name",
		render: (rowData) => (rowData.site_name === null ? "-" : rowData.site_name),
	},
	{ title: "Requested By", field: "requestedBy" },
	{
		title: "Status",
		field: "site_status",
		cellStyle: (e, rowData) => {
			return rowData.site_status?.includes("Rejected")
				? { backgroundColor: "#F08080" }
				: rowData.site_status?.includes("Manager's Approval")
					? { backgroundColor: "#FFD700" }
					: rowData.site_status?.includes("Approved. Waiting for IT")
						? { backgroundColor: "#1F6E8C" }
						: rowData.site_status?.includes("Created") ||
							  rowData.site_status?.includes("Executed")
							? { backgroundColor: "#9ACD32" }
							: null;
		},
	},
];

/**
 * Columns for material-table for EVN Invoice Inputs
 */
export const EVNCOLS = [
	{ title: "Client", field: "client", editable: "never" },
	{ title: "Site", field: "site", editable: "never" },
	{
		title: "Start Date",
		field: "startDate",
		type: "date",
		validate: (rowData) =>
			rowData.startDate === null
				? { isValid: false, helperText: "Start Date cannot be empty" }
				: true,
		render: (rowData) =>
			rowData.startDate === null
				? "-"
				: moment(rowData.startDate).format("DD/MM/YYYY"),
	},
	{
		title: "End Date",
		field: "endDate",
		type: "date",
		validate: (rowData) =>
			rowData.endDate === null
				? { isValid: false, helperText: "End Date cannot be empty" }
				: true,
		render: (rowData) =>
			rowData.endDate === null
				? "-"
				: moment(rowData.endDate).format("DD/MM/YYYY"),
	},
	{ title: "Peak Hour Delivered​", field: "onDe", type: "numeric" },
	{ title: "Off Hour Delivered​", field: "offDe", type: "numeric" },
	{ title: "Standard Hour Delivered​", field: "stdDe", type: "numeric" },
	{ title: "Total Delivered", field: "totalDe", editable: "never" },
];

/**
 * Columns for material-table for MSA Invoice Inputs
 */

export const msa_additional_info_cols = [
	{ title: "Client", field: "client", editable: "never", width: 250 },
	{ title: "Site", field: "site", editable: "never", width: 250 },
	{ title: "MSA Date", field: "msa", editable: "never", width: 250 },
	{ title: "No. of Days", field: "totalDays", width: 150 },
	{ title: "Note", field: "note", width: 300 },
];

const msa_num_pattern = /^(\d{1,9}(\.[0-9]{1,3})?|0\.[0-9]{1,3})$/;
export const msa_price_input_cols = [
	{ title: "Client", field: "client", editable: "never", width: 250 },
	{ title: "Site", field: "site", editable: "never", width: 250 },
	{ title: "MSA Date", field: "msa", editable: "never", width: 250 },
	{
		title: "Unit Price (THB)",
		field: "unitPrice",
		validate: (rowData) =>
			msa_num_pattern.test(rowData.unitPrice)
				? true
				: {
						isValid: false,
						helperText: "Unit price must be in pattern of number",
					},
		width: 300,
	},
	{
		title: "Quantity",
		field: "totalDays",
		validate: (rowData) =>
			msa_num_pattern.test(rowData.totalDays)
				? true
				: { isValid: false, helperText: "Days must be in pattern of number" },
		width: 150,
	},
	{ title: "Note", field: "note", width: 300 },
];

/**
 * Columns for material-table for Delivered/ Estimated Production
 */
export const PRODUCTIONCOLS = [
	{ title: "Date", field: "dateData" },
	{
		title: "Peak Hours Energy Delivered (kWh)",
		field: "deliveredON",
	},
	{
		title: "Standard Hours Energy Delivered (kWh)",
		field: "deliveredOFF",
	},
	{ title: "Total Energy Delivered (kWh)", field: "deliveredTotal" },
];
